import React, {useContext, useState} from 'react'
import { useTranslation } from "react-i18next";
import { IconButton } from '@fluentui/react/lib/Button';
import { getTheme, mergeStyleSets, FontWeights, Modal } from '@fluentui/react';
import {  Row, Col } from "react-bootstrap"
import PropTypes from 'prop-types';


import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import { isNullUndefined, isNullUndefinedOrEmptyOrZero, showMessage } from '../../../../../../common/Helpers';
import { DefaultButton } from '@fluentui/react';
import CLabel from "../../../../../Common/CLabel";
import moment from 'moment';
import CDatePicker from '../../../../../Common/CDatePicker';
import { deleteBoardComponentComment, setBoardComponentComment } from '../../../../../../services/sKPI/board.service';
import CValidator from '../../../../../Common/CValidator';
import { isArray } from 'lodash-es';
import MainAppContext from '../../../../../../MainAppContext';

    function TextEditor(props) {
        const contextSite = useContext(MainAppContext);
        
        const { t } = useTranslation();
        
        const { 
            inputParam_Component = null,
            inputParam_ComponentType = null,
            inputParam_SetterControlValueList = null,
            inputParam_ControlValueList = null,
            inputParam_Item = null,
            inputParam_ClassName = "",
            inputParam_SetterControlValue = null,
            inputParam_IsModalOpen = null,
            inputParam_SetterIsPanelOpen = null,
            inputParam_ElementId = null,
        } = props;

        const theme = getTheme();
        const contentStyles = mergeStyleSets({
            container: {
                display: 'flex',
                flexFlow: 'column nowrap',
                alignItems: 'stretch',
            },
            header: [
                {
                    flex: '1 1 auto',
                    borderTop: `4px solid ${theme.palette.themePrimary}`,
                    color: theme.palette.neutralPrimary,
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: FontWeights.semibold,
                    padding: '12px 12px 14px 24px',
                },
            ],
            body: {
                flex: '4 4 auto',
                padding: '0 24px 24px 24px',
                overflowY: 'hidden',
                selectors: {
                    p: { margin: '14px 0' },
                    'p:first-child': { marginTop: 0 },
                    'p:last-child': { marginBottom: 0 },
                },
            },
            footer: [
                {
                    flex: '1 1 auto',
                    borderTop: `1px solid ${theme.palette.green}`,
                    color: theme.palette.neutralPrimary,
                    display: 'flex',
                    fontWeight: FontWeights.semibold,
                    padding: '0px 5px 14px 5px',
                },
            ],
        });
        const iconButtonStyles = {
            root: {
                color: theme.palette.neutralPrimary,
                marginLeft: 'auto',
                marginTop: '4px',
                marginRight: '2px',
            },
            rootHovered: {
                color: theme.palette.neutralDark,
            },
        };

        //Parametros de componente.
        const baseText = inputParam_Item ? inputParam_Item.value : "";
        const [objComment, setObjComment] = useState({id: inputParam_Item ? inputParam_Item.id : 0, comment: inputParam_Item ? inputParam_Item.value : "", date: inputParam_Item ? inputParam_Item.date : Date.now()});
        const [readOnly, setReadOnly] = useState(true);
        const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(inputParam_Item ? inputParam_Item.value : ""))));
        const [isInvalidControl, setIsInvalidControl] = useState(false);
        const [messageConfig, setMessageConfig] = useState({ message : null, messageType : __MessageTypes.INFO, showMessage : !readOnly });
        const [messageConfig2, setMessageConfig2] = useState({ message : null, messageType : __MessageTypes.ERROR, showMessage : false });

        //Funciones de componente.
        const isInValidFormControl = (value) => {
            return value === "" ? true : false;
        }

        const checkIfIsInvalidControl = () => {
            const _inputParam_IsInvalidControl = isInvalidControl || objComment.comment === null || objComment.comment === '<p></p>\n' || objComment.date === null;

            return _inputParam_IsInvalidControl;
        }

        const onDismissPanel = () => {
            setReadOnly(true)
            showMessage(setMessageConfig, false, __MessageTypes.INFO, null)
            showMessage(setMessageConfig2, false, null, null)
            inputParam_SetterIsPanelOpen(false);
        };

        //Eventos de componente.
        const onChangeValue = (controlState) => {
            const controlValue = draftToHtml(convertToRaw(controlState.getCurrentContent()))

            setEditorState(controlState);
            setIsInvalidControl(isInValidFormControl(controlValue !== null && controlValue !== ""));
            inputParam_SetterControlValue && inputParam_SetterControlValue(controlValue);
            setObjComment(prevState => ({
                ...prevState,
                comment: controlValue
            }));
        };

        const setCommentDate = (value) => {
            setObjComment(prevState => ({
                ...prevState,
                date: value
            }));
        }

        const onFocusControl = () => {
            if (readOnly) {
                if (!isNullUndefined(objComment.id) && objComment.id !== 0) {
                    if (contextSite.securityProps.isAdmin) {
                        setReadOnly(!readOnly)
                    }
                }
                else {
                    setReadOnly(!readOnly)
                }

                showMessage(setMessageConfig, true, __MessageTypes.INFO, null)
            }
        };

        const onClean = () => {
            const emptyContentState = ContentState.createFromText('');
            setEditorState(EditorState.createWithContent(emptyContentState));
        };

        const onSave = () => {
            if (!checkIfIsInvalidControl()) {
                setBoardComponentComment(
                    inputParam_ElementId,
                    (inputParam_ComponentType === 2 ? (!isNullUndefinedOrEmptyOrZero(inputParam_Component.htmlBoardAnexoRef) && inputParam_Component.htmlBoardAnexoRef !== " " ? inputParam_Component.htmlBoardAnexoRef : inputParam_Component.id) : 0),
                    (inputParam_ComponentType === 1 ? (!isNullUndefinedOrEmptyOrZero(inputParam_Component.htmlBoardAnexoRef) && inputParam_Component.htmlBoardAnexoRef !== " " ? inputParam_Component.htmlBoardAnexoRef : inputParam_Component.id) : 0),
                    objComment.id,
                    objComment.comment,
                    objComment.date).then((response) => {

                    if (response.data.succeeded) {
                        objComment.id = response.data.data;
                        let aux_comment = {date: null, value: null, id: null}
                        aux_comment.id = objComment.id
                        aux_comment.date = moment(new Date(objComment.date)).format('YYYY-MM-DD') + 'T00:00:00'
                        aux_comment.value = objComment.comment
                        //Si es create set de listado, agregar comentario al listado para que se actualice el listado de la pagina.
                        //Si es update set de comentario para que se actualice el listado de la pagina.
                        setReadOnly(true)
                        let aux_comments = {...inputParam_ControlValueList}
                        if (isArray(aux_comments.comments.value)) {
                            if (isNullUndefined(aux_comments.comments.value.find(x => x.id === aux_comment.id))) {
                                aux_comments.comments.value.push(aux_comment);
                            }
                            else {
                                aux_comments.comments.value.forEach(element => {
                                    if (element.id === aux_comment.id) {
                                        element.value = aux_comment.value;
                                        element.date = aux_comment.date;
                                    }
                                });
                            }
                        }
                        else {
                            aux_comments = aux_comment;
                        }

                        inputParam_SetterControlValueList && inputParam_SetterControlValueList(aux_comments)

                        setObjComment({...objComment})

                        showMessage(setMessageConfig, false, __MessageTypes.INFO, null)
                        showMessage(setMessageConfig2, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        setReadOnly(false)
                        showMessage(setMessageConfig, true, __MessageTypes.INFO, null)
                        showMessage(setMessageConfig2, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    setReadOnly(false)
                    showMessage(setMessageConfig, true, __MessageTypes.INFO, null)
                    showMessage(setMessageConfig2, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                setReadOnly(false)
                showMessage(setMessageConfig, true, __MessageTypes.INFO, null)
                showMessage(setMessageConfig2, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        };

        const onDelete = () => {
            if (!checkIfIsInvalidControl()) {
                deleteBoardComponentComment(objComment.id).then((response) => {
                    if (response.data.succeeded) {
                        setReadOnly(true)
                        let aux_comments = {...inputParam_ControlValueList}
                        if (isArray(aux_comments.comments.value)) {
                            aux_comments.comments.value = aux_comments.comments.value.filter(x => x.id !== objComment.id);
                        }
                        else {
                            aux_comments.comments.id = 0;
                            aux_comments.comments.value = "";
                            aux_comments.comments.date = null;
                        }

                        inputParam_SetterControlValueList && inputParam_SetterControlValueList(aux_comments)

                        showMessage(setMessageConfig, false, __MessageTypes.INFO, null)
                        showMessage(setMessageConfig2, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        setReadOnly(false)
                        showMessage(setMessageConfig, true, __MessageTypes.INFO, null)
                        showMessage(setMessageConfig2, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    setReadOnly(false)
                    showMessage(setMessageConfig, true, __MessageTypes.INFO, null)
                    showMessage(setMessageConfig2, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                setReadOnly(false)
                showMessage(setMessageConfig, true, __MessageTypes.INFO, null)
                showMessage(setMessageConfig2, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        };

        const onCancel = () => {
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(baseText))))
            setReadOnly(true)
            showMessage(setMessageConfig, false, __MessageTypes.INFO, null)
            showMessage(setMessageConfig2, false, null, null)
        };

        //Render de componente.
        return (
            <Modal
                isOpen={ inputParam_IsModalOpen }
                onDismiss={ inputParam_SetterIsPanelOpen }
                isBlocking={false}
                containerClassName={contentStyles.container}
                dragOptions={ false }            
                className="custom-modal-document-link"
            >
                <div className={contentStyles.header}>
                    <span>{ t('data-lang-lbl-comment') }</span>
                    <IconButton
                        styles={iconButtonStyles}
                        iconProps={{ iconName: 'Cancel' }}
                        onClick={ inputParam_SetterIsPanelOpen }
                    />
                </div>
                <div className={ contentStyles.body} style={{height: "400px"}}> 
                    <div className='h-100' style={{ position: "relative" }}>
                        <Row className='pt-3'>
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-commentdate')}/>
                            </Col>
                            <Col xl={12}>
                                <CDatePicker
                                    controlName={""}
                                    controlValue={moment(objComment.date).toDate()}
                                    setterControlValue={setCommentDate}
                                    isInValid={objComment.date === null}
                                    disabled={false}
                                />
                            </Col>
                        </Row>
                        <Row className='h-80'>
                            <Col xl={12} className='h-100' onClick={onFocusControl}>
                                <Editor
                                    readOnly={readOnly}
                                    onFocus={onFocusControl}
                                    toolbar={{
                                        options: ['inline', 'blockType', 'fontSize', 'textAlign'],
                                        inline: { inDropdown: true },
                                        list: { inDropdown: true },
                                        textAlign: { inDropdown: true },
                                        link: { inDropdown: true },
                                    }}
                                    editorState={ editorState }
                                    wrapperClassName={`demo-wrapper2 h-100 ${readOnly ? 'cursor-pointer ' : ''} ${inputParam_ClassName}`}
                                    editorClassName="demo-editor2  h-100"
                                    onEditorStateChange={ onChangeValue }
                                    value={objComment.comment}
                                    toolbarHidden={readOnly}
                                />
                                <CValidator isInValid={ objComment.comment === null || objComment.comment === "<p></p>\n" } isInValidText={ t('data-lang-msg-required') } />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className={contentStyles.footer}>
                    <Col>
                        <Col xl={12}>
                            <MessageBox
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                                inputParam_OnCloseExtender={onCancel}
                                inputParam_MessageLink={ [
                                    {key: "clear", linkFunc: onClean, text: t('data-lang-lbl-clean')},
                                    {key: "save", linkFunc: onSave, text: t('data-lang-btn-save')},
                                    {key: "delete", linkFunc: onDelete, text: t('data-lang-btn-delete')},
                                    {key: "cancel", linkFunc: onCancel, text: t('data-lang-btn-cancel')}
                                ].filter(x => contextSite.securityProps.isAdmin === false ? (x.key !== "delete") : true) }
                            />
                        </Col>
                        
                        <div className="text-end pt-1">
                            <Row className='p-0 m-0'>
                                <Col className='p-0 pe-1 m-0'>
                                    <MessageBox
                                        inputParam_Message={ messageConfig2.message }
                                        inputParam_Display={ messageConfig2.showMessage }
                                        inputParam_MessageType={ messageConfig2.messageType }
                                        inputParam_SetterMessage={ setMessageConfig2 }
                                    />
                                </Col>
                                <Col className='col-auto mx-auto me-auto p-0 m-0'>
                                    <DefaultButton onClick={ onDismissPanel }>{ t('data-lang-btn-close') }</DefaultButton>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </div>
            </Modal>
            );
    }
        
    export default TextEditor;